(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/tipsinfo/assets/javascripts/tipsinfo.js') >= 0) return;  svs.modules.push('/components/tipsen/tipsinfo/assets/javascripts/tipsinfo.js');
"use strict";

const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const selectShowMatchAnalyseForecast = svs.components.tipsen.selectors.selectShowMatchAnalyseForecast;
const selectSportEvent = svs.components.sportinfo.matchInfoRedux.selectors.selectSportEvent;
const _svs$components$tipse = svs.components.tipsen.tipsinfo,
  TipsinfoRow = _svs$components$tipse.TipsinfoRow,
  TipsinfoRowText = _svs$components$tipse.TipsinfoRowText,
  TipsinfoTable = _svs$components$tipse.TipsinfoTable,
  TipsinfoRows = _svs$components$tipse.TipsinfoRows;
const _svs$components$sport = svs.components.sportinfo.common.constants,
  EventTypeId = _svs$components$sport.EventTypeId,
  EventTypeField = _svs$components$sport.EventTypeField;
const selectEngineDefinition = svs.components.tipsen.engine.selectors.selectEngineDefinition;
const _svs$components$tipse2 = svs.components.tipsen.tipsinfo.utils,
  createSelectFormattedDistribution = _svs$components$tipse2.createSelectFormattedDistribution,
  createSelectFormattedOdds = _svs$components$tipse2.createSelectFormattedOdds;
const useBetEvent = svs.components.sportinfo.matchInfoHooks.useBetEvent;
const useIsTipsinfoEnabled = svs.components.tipsen.hooks.useIsTipsinfoEnabled;
const createEventStatisticsKey = svs.components.sportinfo.common.helpers.createEventStatisticsKey;
const selectEventStatisticCurrentValueByType = svs.components.sportinfo.matchInfoRedux.selectors.selectEventStatisticCurrentValueByType;
const formatOdds = svs.utils.format.Odds;
const _React = React,
  useContext = _React.useContext;
const RenderContext = svs.component.tipsen.renderContext.RenderContext;
const detect = svs.core.detect;
const getOverUnderOddsAsText = oddsValues => {
  if (!oddsValues || oddsValues.length < 2) {
    return '-';
  }
  return "".concat(formatOdds(oddsValues[0]) || '-', "/").concat(formatOdds(oddsValues[1]) || '-');
};
const Tipsinfo = _ref => {
  var _tioTidningarTips$cur;
  let drawNumber = _ref.drawNumber,
    productId = _ref.productId,
    eventNumber = _ref.eventNumber,
    outcomeLabels = _ref.outcomeLabels,
    _ref$isReduceFree = _ref.isReduceFree,
    isReduceFree = _ref$isReduceFree === void 0 ? false : _ref$isReduceFree;
  const _useBetEvent = useBetEvent({
      productId,
      drawNumber,
      eventNumber
    }),
    betEvent = _useBetEvent.betEvent,
    eventStatistics = _useBetEvent.eventStatistics;
  const matchId = betEvent.matchId,
    eventTypeId = betEvent.eventTypeId,
    periodNumber = betEvent.periodNumber;
  const _useContext = useContext(RenderContext),
    pageType = _useContext.pageType,
    isResultOrMybets = _useContext.isResultOrMybets;
  const sportEvent = useSelector(state => selectSportEvent(state, matchId));
  const isHead2Head = betEvent.eventTypeId === EventTypeId.HEAD_TO_HEAD;
  const selectFormattedOdds = createSelectFormattedOdds({
    matchId,
    eventTypeId,
    periodNumber,
    eventNumber
  });
  const selectFormattedDistribution = createSelectFormattedDistribution({
    drawNumber,
    eventTypeId,
    matchId,
    periodNumber,
    productId,
    eventNumber
  });
  const _useIsTipsinfoEnabled = useIsTipsinfoEnabled(pageType),
    isMatchStartEnabled = _useIsTipsinfoEnabled.isMatchStartEnabled,
    isTioTidningarEnabled = _useIsTipsinfoEnabled.isTioTidningarEnabled,
    isStartOddsEnabled = _useIsTipsinfoEnabled.isStartOddsEnabled,
    isOddsEnabled = _useIsTipsinfoEnabled.isOddsEnabled,
    isFavouritesEnabled = _useIsTipsinfoEnabled.isFavouritesEnabled,
    isSvenskaFolketEnabled = _useIsTipsinfoEnabled.isSvenskaFolketEnabled,
    isSvenskaFolketAsOutcomesEnabled = _useIsTipsinfoEnabled.isSvenskaFolketAsOutcomesEnabled,
    isOverUnderEnabled = _useIsTipsinfoEnabled.isOverUnderEnabled;
  const _ref2 = eventStatistics || {},
    favourites = _ref2.favourites,
    startOdds = _ref2.startOdds,
    tioTidningarTips = _ref2.tioTidningarTips;
  const eventStatisticsKey = createEventStatisticsKey({
    matchId,
    eventTypeId: EventTypeId.OVER_UNDER,
    periodNumber: betEvent.periodNumber,
    eventNumber: betEvent.eventNumber
  });
  const overUnderOdds = useSelector(state => selectEventStatisticCurrentValueByType(state, eventStatisticsKey, EventTypeField.Odds));
  const shouldDisplayLargeTipsinfo = isSvenskaFolketAsOutcomesEnabled;
  const shouldDisplaySvenskaFolket = isSvenskaFolketEnabled && (!isSvenskaFolketAsOutcomesEnabled || isReduceFree);
  const shouldDisplayOdds = isOddsEnabled && !isHead2Head;
  const shouldDisplayStartOdds = isStartOddsEnabled;
  const shouldDisplayTioTidningar = !detect.feature('ft-ttt-disable') && isTioTidningarEnabled && !isHead2Head;
  const shouldDisplayMatchstart = isMatchStartEnabled;
  const shouldDisplayFavourites = isFavouritesEnabled;
  const hasTipsinfoStats = shouldDisplayOdds || shouldDisplayStartOdds || shouldDisplaySvenskaFolket || shouldDisplayTioTidningar || shouldDisplayFavourites || shouldDisplayMatchstart;
  const shouldDisplayOverUnder = isOverUnderEnabled;
  const showMatchAnalyseForecast = useSelector(state => selectShowMatchAnalyseForecast(state, pageType));
  const hasTioTidningarValues = (tioTidningarTips === null || tioTidningarTips === void 0 || (_tioTidningarTips$cur = tioTidningarTips.current) === null || _tioTidningarTips$cur === void 0 || (_tioTidningarTips$cur = _tioTidningarTips$cur.value) === null || _tioTidningarTips$cur === void 0 ? void 0 : _tioTidningarTips$cur.length) > 0;
  const outcomeLabelsLength = (outcomeLabels === null || outcomeLabels === void 0 ? void 0 : outcomeLabels.length) || 0;
  const currentEngine = useSelector(selectEngineDefinition);
  const isGoalCount = currentEngine.outcomes.eventTypeId === EventTypeId.GOAL_COUNT;
  const layOutProps = {
    drawNumber,
    eventNumber,
    favourites,
    hasTioTidningarValues,
    hasTipsinfoStats,
    isGoalCount,
    isReduceFree,
    isResultOrMybets,
    isStartOddsEnabled,
    matchId,
    outcomeLabels,
    productId,
    selectFormattedDistribution,
    selectFormattedOdds,
    shouldDisplayFavourites,
    shouldDisplayLargeTipsinfo,
    shouldDisplayOdds,
    shouldDisplayStartOdds,
    shouldDisplaySvenskaFolket,
    shouldDisplayTioTidningar,
    showMatchAnalyseForecast,
    startOdds,
    tioTidningarTips
  };
  return React.createElement("div", {
    className: "tipsinfo tipsinfo-".concat(outcomeLabelsLength, "col")
  }, isGoalCount ? React.createElement(TipsinfoRows, {
    layOutProps: layOutProps
  }) : React.createElement(TipsinfoTable, {
    layOutProps: layOutProps
  }), shouldDisplayOverUnder && isGoalCount && React.createElement("div", {
    className: "tipsinfo-border-fulltraff"
  }), shouldDisplayOverUnder && React.createElement(TipsinfoRow, {
    className: "coupon-row-tips-info-overunder",
    dataTestId: "coupon-row-tips-info-overunder",
    isGoalCount: isGoalCount,
    title: "Odds - \xD6ver/Under 2,5 m\xE5l"
  }, React.createElement(TipsinfoRowText, {
    className: "tipsinfo-row-matchstart margin-left-half"
  }, getOverUnderOddsAsText(overUnderOdds))), shouldDisplayMatchstart && isGoalCount && React.createElement("div", {
    className: "tipsinfo-border-fulltraff"
  }), shouldDisplayMatchstart && React.createElement(TipsinfoRow, {
    className: "coupon-row-tips-info-matchstart",
    dataTestId: "coupon-row-tips-info-matchstart",
    date: sportEvent.matchStart,
    isGoalCount: isGoalCount,
    title: "".concat(isGoalCount ? 'Matchstart' : 'Matchstart:')
  }, React.createElement(TipsinfoRowText, {
    className: "tipsinfo-row-matchstart margin-left-half"
  }, svs.components.lbUtils.helpers.formatDate.formatDate(sportEvent.matchStart, true, true, true))));
};
setGlobal('svs.components.tipsen.tipsinfo.Tipsinfo', Tipsinfo);

 })(window);